<!--Modal Cookie-->
<div id="cookieNotify" class="modal-strip cookie-notify background-dark"
[class.modal-active]="cookiesIsAccepted === null"
data-delay="3000" data-expire="1" *ngIf="cookiesIsAccepted === null">
  <div class="container">
      <div class="row">
          <div class="col-lg-12 text-center center m-b-10 m-t-5">
            Ce site utilise des cookies afin de vous assurer la meilleure expérience possible.
            <a routerLink="/divers/protection-donnees"  class="text-light"><span> Plus d'infos <i class="fa fa-info-circle"></i></span></a>
          </div>
          <div class="col-lg-12  text-center center">
              <button type="button" class="btn btn-roundeded btn-light btn-outline btn-sm  m-r-10 modal-close" (click)="reject()">uniquement les cookies essentiels</button>
              <button type="button" class="btn btn-roundeded btn-light btn-sm modal-confirm sm-m-t-10" (click)="accept()">J'accepte!</button>
          </div>
      </div>
  </div>
</div>
<!--End: Modal Cookie-->
